import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import { useSupabaseClient } from '@supabase/auth-helpers-react';
import { validatePassword } from '../../utils/validation';
import './Auth.css';

export default function ResetPasswordPage() {
  const supabase = useSupabaseClient();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');

    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (password !== confirmPassword) {
      setError('הסיסמאות לא תואמות');
      return;
    }

    try {
      setLoading(true);
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      console.error('Reset password error:', err);
      if (err.message?.includes('same_password')) {
        setError('הסיסמה החדשה חייבת להיות שונה מהסיסמה הנוכחית');
      } else {
        setError('שגיאה בעדכון הסיסמה. נסה שוב');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container login-background">
      <div className="auth-box">
        <h2>איפוס סיסמה</h2>
        {error && <div className="error-message">{error}</div>}
        {success ? (
          <div className="reset-success" style={{ padding: '20px 0' }}>
            הסיסמה עודכנה בהצלחה! מעביר לדף הכניסה...
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group password-input-container">
              <label>סיסמה חדשה</label>
              <div className="input-with-icon">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  minLength={8}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(s => !s)}
                  className="password-toggle"
                  aria-label="toggle password visibility"
                >
                  {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label>אימות סיסמה</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                required
                minLength={8}
              />
            </div>
            <button disabled={loading} type="submit" className="login-button">
              {loading ? 'מעדכן...' : 'עדכן סיסמה'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
